export const SET_ZOOM_IMAGE_URL = 'general/SET_ZOOM_IMAGE_URL'
